import React, { FC } from "react";

import Tooltip from "@vromo/ui/components/Tooltip";

interface Props {
  label ?: string;
}

const ConditionalTooltip: FC<Props> = ({ label, children }) => {
  return !!label
    ? (
      <Tooltip label={label}>
        {children}
      </Tooltip>)
    : <>{children}</>;
}

export default ConditionalTooltip
